import { create } from "zustand";

export interface ActionbarAuth {
  queryAut?: string;
  insertAut?: string;
  deleteAut?: string;
  saveAut?: string;
  printAut?: string;
  excelAut?: string;
  initAut?: string;
}

interface ActionbarStore {
  auth: ActionbarAuth | null;
  setAuth: (auth: ActionbarAuth) => void;
  clearAuth: () => void;
}

const useActionbarAuthStore = create<ActionbarStore>((set) => ({
  auth: null,
  setAuth: (auth) => set({ auth }),
  clearAuth: () => set({ auth: null }),
}));

export default useActionbarAuthStore;